import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { list, find, save, remove } from '../../services/qualityControl'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'

function* fetchQualityControlsRefresh() {
  let fe = JSON.parse(localStorage.getItem('fetchQualityControls'))
  if (fe == null) {
    fe = {}
    fe.size = localStorage.getItem('pageSize') || 15
    fe.index = 0
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  } else {
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_QUALITYCONTROL,
    result,
  })
}

function* fetchQualityControls({ size, index, searchTerm, orderBy, date, inventoryNumber }) {
  console.log('fetchQualityControls', size, index, searchTerm, orderBy, date, inventoryNumber)
  size = size || localStorage.getItem('pageSize') || 15

  const savedFilters = localStorage.getItem('qualityControlFilters')

  if (savedFilters) {
    const parsedFilters = JSON.parse(savedFilters)

    date = date || parsedFilters.date || null
    inventoryNumber = inventoryNumber || parsedFilters.inventoryNumber || ''
  }

  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy, date, inventoryNumber)
  yield put({
    type: actions.LIST_QUALITYCONTROL,
    result,
  })
}

function* fetchQualityControlEdit({ id, openModal }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id, openModal)
  console.log('fetchQualityControlEdit', result)
  yield put({
    type: actions.EDIT_QUALITYCONTROL,
    result,
    openModal,
  })
}

function* fetchQualityControlSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  if (result !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  }
  yield put({
    type: actions.SAVE_QUALITYCONTROL_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_QUALITYCONTROLS,
  })
}

function* fetchQualityControlDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_QUALITYCONTROL_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_QUALITYCONTROLS,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_QUALITYCONTROLS, fetchQualityControls),
    takeEvery(actions.FETCH_QUALITYCONTROL, fetchQualityControlEdit),
    takeEvery(actions.SAVE_QUALITYCONTROL, fetchQualityControlSave),
    takeEvery(actions.DELETE_QUALITYCONTROL, fetchQualityControlDelete),
    takeEvery(actions.RE_FETCH_QUALITYCONTROLS, fetchQualityControlsRefresh),
  ])
}
